import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';

import { ItSupportDialogComponent } from './it-support-dialog.component';

@Injectable()
export class ItSupportDialog {
  #dialog = inject(DialogService);

  open(): DialogRef {
    return this.#dialog.open(ItSupportDialogComponent);
  }
}
